import { render } from "./MotivoRechazoForm.vue?vue&type=template&id=a40f5ad4"
import script from "./MotivoRechazoForm.vue?vue&type=script&lang=js"
export * from "./MotivoRechazoForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__